// Copyright 2005-2011 Jim Radford <radford@blackbean.org> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, in_order_by=piles.in_order_by, count_top_order_by=piles.count_top_order_by,
                                in_suit_order=piles.in_suit_order, in_color_order=piles.in_color_order, in_numeric_order=piles.in_numeric_order,
                                up=piles.up, down=piles.down, clubs=piles.clubs, diamonds=piles.diamonds, hearts=piles.hearts, spades=piles.spades, king=piles.king;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var lib = require('./lib');
var options = require('./options'), option_def=options.option_def;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;

solitaire.spider = class extends pile_game {
    constructor(name, ui) {
        super(name, ui);
        this.pile_game_init(name, ui);
        this.decks = 8 / this.options.suits;
        this.stock = new this.stock_pile("stock", this);
        this.foundation = [];
        for (let i=1; i<=8; i++)
            this.foundation.push(new this.foundation_pile("good"+i, this));
        this.tableau = [];
        for (let i=1; i<=10; i++)
            this.tableau.push(new this.tableau_pile("tableau"+i, this));

        this.ui.deck_play =
            this.stock.onclick = function() {
                if (!this.stock.pile.length) return;
                var cards=0, empty;
                for (let i=0; i<this.tableau.length; i++) {
                    empty = empty || this.tableau[i].pile.length == 0;
                    cards += this.tableau[i].pile.length;
                }
                if (cards >= this.tableau.length && empty) return;
                this.push_state();
                this.moves.push("*"+this.stock.move_char());
                for (let i=0; i<this.tableau.length; i++)
                    if (this.stock.pile.length) {
                        this.stock.top().face = up;
                        this.animate_move(this.do_move([{ from:this.stock, to:this.tableau[i], fstart:this.stock.top_index(), n:1, internal:true }]));
                    }
                this.end_of_move();
            }.bind(this);
    }

    static variants = { spider1: { suits: 1 },
                        spider2: { suits: 2 },
                        tarantula: {},
                        "black widow": {} };

    valid_options = { suits: option_def("number", 4, "Number of Suits") };

    foundation_pile = class extends pile_game.generic_foundation {
        accept_stacks = true;
        accept(cards) { return cards.length == 13 ? pile_game.generic_foundation.prototype.accept.call(this, cards) : 0; }
        split_move = undefined;
    };

    tableau_pile = class extends pile {
        constructor(div,game) {
            super(div,game);
            this.drag_order = game.name.match(/spider/) ? in_suit_order :
                              game.name == "tarantula" ? in_color_order :
                              game.name == "black widow" ? in_numeric_order : undefined;
            this.maxstack = Math.ceil([void 0, 15.2458481613286, 16.2236947791165, void 0, 18.2653846153846][game.options.suits]); // Determined by query in upgrades/maxstack.sql
        }
        accept_stacks = true;
        accept(cards) { return  (this.pile.length == 0 ? 1 : 0)
                                || (in_suit_order(cards[0],this.top()) ? 3 + count_top_order_by(this.drag_order, this.pile) : 0)
                                || (in_numeric_order(cards[0],this.top()) ? 2 : 0); }
        can_drag(index) { return in_order_by(this.drag_order, this.pile, index); }
        splice = pile.prototype.splice_and_turn_over;
        xoffset = 0;
    }

    stock_pile = class extends pile {
        accept(card) { return false; }
        can_drag(index) { return false; }
        xoffset = .3/90;
        yoffset = .3/131;
        maxstack = 54;
    }

    deal(deck) {
        this.options.suits = {1:true,2:true,4:true}[this.options.suits] ? this.options.suits : 4; // sanity
        var suits = {}; suits[diamonds]=4; suits[clubs]=4; suits[hearts]=2; suits[spades]=1;
        this.stock.pile = []
        for (let c of deck)
            if (this.options.suits >= suits[c.suit])
                this.stock.pile.push(c)
        for (let c=0; c<54; c++)
            this.tableau[c%this.tableau.length].push(this.stock.pop());
        for (let pile of this.tableau)
            pile.top().face = up;
    }

    fix_replay_move(moves) {
        return moves.replace(/^090a0b0c0d0e0f0g0h0i/, "*0").      // Dealing
            replace(/^(([9a-i])([1-8])){13}/, "$2:d$3"); // Pile to foundation (not quite checked properly)
    }

    is_complete() {
        for (let f of this.foundation)
            if (f.pile.length != 13)
                return NOT_COMPLETE;
        return WON;
    }

    disabled_complete() {
        let step = async () => {
            let did_something = false;
            for (let pile of this.tableau) {
                let ordered = count_top_order_by(pile.drag_order, pile.pile);
                if (ordered == 13 || ordered != pile.pile.length || (pile.pile[0] && pile.pile[0].rank != king)) {
                    let l = pile.pile.length;
                    let m = await pile.fake_click(0);
                    if (m && m.to.pile.length != l)
                        did_something = true;
                }
            }
            if (did_something)
                step();
        };
        step();
    }

    score() {
        return this.count_cards_in(this.foundation);
    }

    layout = grid(["stock",    void 0,     "good1",    "good2",    "good3",    "good4",    "good5",    "good6",    "good7",    "good8"],
                  [{y: +.1},
                   "tableau1", "tableau2", "tableau3", "tableau4", "tableau5", "tableau6", "tableau7", "tableau8", "tableau9", "tableau10"]);
}

module.exports = solitaire.spider;
// Copyright 2005-2011 Jim Radford <radford@blackbean.org> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, in_order_by=piles.in_order_by, count_top_order_by=piles.count_top_order_by,
                                in_suit_order=piles.in_suit_order, in_color_order=piles.in_color_order, in_numeric_order=piles.in_numeric_order,
                                up=piles.up, down=piles.down, clubs=piles.clubs, diamonds=piles.diamonds, hearts=piles.hearts, spades=piles.spades, king=piles.king;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var lib = require('./lib');
var options = require('./options'), option_def=options.option_def;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;

solitaire.spider = class extends pile_game {
    constructor(name, ui) {
        super(name, ui);
        this.pile_game_init(name, ui);
        this.decks = 8 / this.options.suits;
        this.stock = new this.stock_pile("stock", this);
        this.foundation = [];
        for (let i=1; i<=8; i++)
            this.foundation.push(new this.foundation_pile("good"+i, this));
        this.tableau = [];
        for (let i=1; i<=10; i++)
            this.tableau.push(new this.tableau_pile("tableau"+i, this));

        this.ui.deck_play =
            this.stock.onclick = function() {
                if (!this.stock.pile.length) return;
                var cards=0, empty;
                for (let i=0; i<this.tableau.length; i++) {
                    empty = empty || this.tableau[i].pile.length == 0;
                    cards += this.tableau[i].pile.length;
                }
                if (cards >= this.tableau.length && empty) return;
                this.push_state();
                this.moves.push("*"+this.stock.move_char());
                for (let i=0; i<this.tableau.length; i++)
                    if (this.stock.pile.length) {
                        this.stock.top().face = up;
                        this.animate_move(this.do_move([{ from:this.stock, to:this.tableau[i], fstart:this.stock.top_index(), n:1, internal:true }]));
                    }
                this.end_of_move();
            }.bind(this);
    }

    static variants = { spider1: { suits: 1 },
                        spider2: { suits: 2 },
                        tarantula: {},
                        "black widow": {} };

    valid_options = { suits: option_def("number", 4, "Number of Suits") };

    foundation_pile = class extends pile_game.generic_foundation {
        accept_stacks = true;
        accept(cards) { return cards.length == 13 ? pile_game.generic_foundation.prototype.accept.call(this, cards) : 0; }
        split_move = undefined;
    };

    tableau_pile = class extends pile {
        constructor(div,game) {
            super(div,game);
            this.drag_order = game.name.match(/spider/) ? in_suit_order :
                              game.name == "tarantula" ? in_color_order :
                              game.name == "black widow" ? in_numeric_order : undefined;
            this.maxstack = Math.ceil([void 0, 15.2458481613286, 16.2236947791165, void 0, 18.2653846153846][game.options.suits]); // Determined by query in upgrades/maxstack.sql
        }
        accept_stacks = true;
        accept(cards) { return  (this.pile.length == 0 ? 1 : 0)
                                || (in_suit_order(cards[0],this.top()) ? 3 + count_top_order_by(this.drag_order, this.pile) : 0)
                                || (in_numeric_order(cards[0],this.top()) ? 2 : 0); }
        can_drag(index) { return in_order_by(this.drag_order, this.pile, index); }
        splice = pile.prototype.splice_and_turn_over;
        xoffset = 0;
    }

    stock_pile = class extends pile {
        accept(card) { return false; }
        can_drag(index) { return false; }
        xoffset = .3/90;
        yoffset = .3/131;
        maxstack = 54;
    }

    deal(deck) {
        this.options.suits = {1:true,2:true,4:true}[this.options.suits] ? this.options.suits : 4; // sanity
        var suits = {}; suits[diamonds]=4; suits[clubs]=4; suits[hearts]=2; suits[spades]=1;
        this.stock.pile = []
        for (let c of deck)
            if (this.options.suits >= suits[c.suit])
                this.stock.pile.push(c)
        for (let c=0; c<54; c++)
            this.tableau[c%this.tableau.length].push(this.stock.pop());
        for (let pile of this.tableau)
            pile.top().face = up;
    }

    fix_replay_move(moves) {
        return moves.replace(/^090a0b0c0d0e0f0g0h0i/, "*0").      // Dealing
            replace(/^(([9a-i])([1-8])){13}/, "$2:d$3"); // Pile to foundation (not quite checked properly)
    }

    is_complete() {
        for (let f of this.foundation)
            if (f.pile.length != 13)
                return NOT_COMPLETE;
        return WON;
    }

    disabled_complete() {
        let step = async () => {
            let did_something = false;
            for (let pile of this.tableau) {
                let ordered = count_top_order_by(pile.drag_order, pile.pile);
                if (ordered == 13 || ordered != pile.pile.length || (pile.pile[0] && pile.pile[0].rank != king)) {
                    let l = pile.pile.length;
                    let m = await pile.fake_click(0);
                    if (m && m.to.pile.length != l)
                        did_something = true;
                }
            }
            if (did_something)
                step();
        };
        step();
    }

    score() {
        return this.count_cards_in(this.foundation);
    }

    layout = grid(["stock",    void 0,     "good1",    "good2",    "good3",    "good4",    "good5",    "good6",    "good7",    "good8"],
                  [{y: +.1},
                   "tableau1", "tableau2", "tableau3", "tableau4", "tableau5", "tableau6", "tableau7", "tableau8", "tableau9", "tableau10"]);
}

module.exports = solitaire.spider;
